import { styled } from "styled-components";
import UserIcon from '../../icons/UserIcon.svg?react';

interface HeaderBarProps {
    title: string;
}

const HeaderBar : React.FC<HeaderBarProps> = ({ title }) => {
    return (
        <HeaderContainer>
            <LogoContainer onClick={() => window.location.reload()}>
                <LogoImg/>
            </LogoContainer>
            <HeaderContent>
                <TitleContainer>
                    {title}
                </TitleContainer>
                <AccountContainer>
                    <AccountName>
                        Mon compte client
                    </AccountName>
                    <AccountIcon>
                        <UserIcon/>
                    </AccountIcon>
                </AccountContainer>
            </HeaderContent>
        </HeaderContainer>
    )
}

const HeaderContainer = styled.div`
    display: flex;
    position: sticky;
    top: 0;
    width: 100%;
    // min-height: 6rem;
    height: 10vh;
    background: #fff;
    z-index: 300;
    flex-direction: row;
    flex-wrap: nowrap;

    @media (max-width: ${props => props.theme.breakpoints?.tablet}) {
        min-height: 5rem;
        padding: 0.5rem 0.5rem;
    }
`

const LogoContainer = styled.div`
    display: flex;
    width: 20%;
    height: 100%;
    align-self: center;
    justify-content: center;
    padding: 1vh 1vw;
    &:hover{
        cursor: pointer;
    }

    @media (max-width: ${props => props.theme.breakpoints?.tablet}) {
        max-height: 3rem;
        padding: 0.5vh 0.5vw;
    }
`

const LogoImg = styled.img.attrs(props => ({
    src: props.theme.logo.src,
    alt: props.theme.logo.alt,
}))`
    width: auto;
    max-width: 100%;
    height: 100%;
`

const HeaderContent = styled.div`
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    width: 100%;

    @media (max-width: ${props => props.theme.breakpoints?.tablet}) {
        max-width: 80vw;
    }
`

const TitleContainer = styled.div`
    flex-grow: 1;
    align-self: center;
    padding: 1vh 1vw;
    font-family: Poppins-ExtraBold, sans-serif;
    font-size: 40px;

    @media (max-width: ${props => props.theme.breakpoints?.tablet}) {
        font-size: 25px;
        padding: 0.5vh 0.5vw;
    }
`

const AccountContainer = styled.div`
    display: flex;
    padding: 1vh 2vw;
    align-items: end;
`

const AccountName = styled.div`
    font-family: Poppins-ExtraBold, sans-serif;
    font-size: 22px;
    font-variant: small-caps;
    margin-right: 2vw;

    @media (max-width: ${props => props.theme.breakpoints?.tablet}) {
        font-size: 16px;
        margin-right: 1vw;
    }
`

const AccountIcon = styled.div`
    width: 3.5rem;
    margin-bottom: .5vh;
    svg {
        width: 100%;
        height: 100%;
    }

    @media (max-width: ${props => props.theme.breakpoints?.tablet}) {
        width: 2.5rem;
        height: 2.5rem;
        margin-bottom: 0.25vh;
    }
`

export default HeaderBar;